import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { HBox, Box } from 'app/views/core/Box'
import { VScroll } from 'app/views/core/Scroll'

import { parseSubmissionDetails } from './util'
import TestSubmissionList from './TestSubmissionList'
import TestSubmissionDetails from './TestSubmissionDetails'

import { connect } from 'react-redux'

function TestOverview(props) {
  const { stages, isRunningTests, isSubmittingPatch, submissions } = props
  const [selectedSubmissionId, setSelectedSubmissionId] = useState(-1)

  // When we get a new code submission, automatically select it
  useEffect(() => {
    if (submissions.length > 0) {
      setSelectedSubmissionId(submissions[0].id)
    }
  }, [submissions.length])

  const selectedSubmission = selectedSubmissionId === -1 ? null : submissions.find((x) => x.id === selectedSubmissionId)
  return (
    submissions.length === 0 ? (
      <Box fillParent style={{ padding: 20 }}>
        <h3 className="uk-margin-remove-bottom">Test Submissions</h3>
        <span className="uk-text-small">No tests have been submitted.</span>
      </Box>
    ) : (
      <HBox fillParent>
        <Box fixed={250}>
          <VScroll>
            <TestSubmissionList 
              submissions={submissions}
              selectedSubmissionId={selectedSubmissionId}
              onSelect={setSelectedSubmissionId}
            />
          </VScroll>
        </Box>
        <Box grow>
          <VScroll>
            {selectedSubmission && (
              <TestSubmissionDetails
                stages={stages}
                {...parseSubmissionDetails(selectedSubmission)}
              />
            )}
          </VScroll>
        </Box>
      </HBox>
    )
  )
}
TestOverview.propTypes = {
  stages: PropTypes.arrayOf(PropTypes.object).isRequired,
  isRunningTests: PropTypes.bool.isRequired,
  submissions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default connect((state) => {
  const shouldShowSubmission = (submission) => submission.test.passed || submission.test.name || !submission.stale
  return {
    isRunningTests: state.repl.runningTests,
    submissions: state.hacker.currentCodeSubmissions.filter(shouldShowSubmission),
  }
}, {})(TestOverview)
